var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cqbz_box"},[_c('iframe',{attrs:{"src":"https://cqbz.996box.com","frameborder":"0"}})])}]

export { render, staticRenderFns }